import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../../firebase';
import '../event/archive_event.css';

const ArchiveNewsDetail = () => {
  const { newsId } = useParams(); // 🟢 Extracts "event_001" directly from your active URL
  const navigate = useNavigate();
  const [newsData, setNewsData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        // Query the collection where the field event_id matches the URL parameter
        const q = query(collection(db, "parmNews"), where("news_id", "==", newsId));
        const snap = await getDocs(q);

        if (!snap.empty) {
          // Since event_id is unique, take the first document match
          setNewsData(snap.docs[0].data());
        } else {
          console.error("No matching archived event found!");
        }
      } catch (err) {
        console.error("Error fetching details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEventDetails();
  }, [newsId]);

  if (loading) return <div className="loader">Loading event profile...</div>;
  if (!newsData) return <div className="error-state">Event profile not found. <button onClick={() => navigate('/archive-news-list-parm')}>Back to Archive</button></div>;

  // Formatting date safely
  const formattedDate = newsData.createdAt?.seconds
    ? new Date(newsData.createdAt.seconds * 1000).toLocaleDateString('en-MY', { year: 'numeric', month: 'long', day: 'numeric' })
    : newsData.createdAt;

  return (
    <article className="archive-event-detail-page">
      <div className="archive-detail-container">
        <button onClick={() => navigate('/archive-news-list-parm')} className="back-btn">⬅ Back to Archives</button>
        
        <header className="archive-event-header">
          <h1>{newsData.news_title}</h1>
          <p className="archive-detail-date">📅 Event Date: {formattedDate}</p>
        </header>

        <hr />

        <section className="archive-event-body">
          {/* Main Description */}
          <div className="archive-event-description">
            <h3>About the News</h3>
            <p style={{ whiteSpace: 'pre-line' }}>{newsData.news_description || "No description provided."}</p>
          </div>

          {/* 🟢 IMAGE GALLERY LAYOUT */}
          {newsData.news_image_array && newsData.news_image_array.length > 0 && (
            <div className="archive-event-gallery-section">
              <h3>News Media Gallery</h3>
              <div className="archive-gallery-grid">
                {newsData.news_image_array.map((imgUrl, index) => (
                  <div key={index} className="archive-gallery-item">
                    <img 
                      src={imgUrl} 
                      alt={`${newsData.news_title} snapshot ${index + 1}`} 
                      onClick={() => window.open(imgUrl, '_blank')} // Simple lightbox fallback zoom effect
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </section>
      </div>
    </article>
  );
};

export default ArchiveNewsDetail;